import React, { useRef, useEffect, useState } from 'react';
import Chart from 'chart.js/auto';

const customRadarChart = {
    id: 'customRadarChart',
    beforeDraw: (chart) => {
        const { ctx, chartArea, scales } = chart;
        if (!chartArea.top) return;

        const tickFontSize = 12;
        const tickOffset = 1;
        const textOffsetX = 0;
        const textOffsetY = -6;

        ctx.save();
        ctx.font = `${tickFontSize}px Arial`;
        ctx.fillStyle = '#BDBDBD';
        if (scales.r) {
            const tickValues = scales.r.getTicks().map(t => t.value);
            const centerX = chartArea.left + (chartArea.right - chartArea.left) / 2;
            const centerY = chartArea.top + (chartArea.bottom - chartArea.top) / 2;
            const radius = scales.r.drawingArea;

            tickValues.forEach((value) => {
                if (value > 0) {
                    const y = centerY - radius * (value / scales.r.max) + textOffsetY;
                    ctx.fillText(value, centerX + tickOffset, y);
                }
            });

            ctx.restore();
        }
    }
};

const RadarChart = ({label,data}) => {
    const chartRef = useRef(null);
    const max=Math.max(...data);
    const level=max>100?50:10;
    useEffect(() => {
        Chart.register(customRadarChart); // 注册插件

        const ctx = chartRef.current.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: label,
                datasets: [{
                    data: data,
                    fill: true,
                    backgroundColor: 'rgba(255, 204, 0, 0.7)',
                    borderColor: '#EEBB00',
                    pointBackgroundColor: '#EEBB00',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: '#FFCC00'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 0 // 设置动画持续时间为0，即禁用动画
                },
                plugins: {
                    customRadarChart,
                    legend: {
                        labels:{
                            generateLabels:e=>{
                                return null;
                            },
                        }
                    }

                },
                scales: {
                    r: {
                        min: 0,
                        max: Math.ceil(max/level)*level,
                        ticks: {
                            stepSize: Math.ceil(max/level)*level/5,
                            backdropColor: 'transparent',
                            display: false // 隐藏默认刻度标签
                        },
                        pointLabels: {
                            padding: 20,
                            font: {
                                size: 14, // 字体大小
                                family: 'SF Pro', // 字体
                                style: 'normal', // 字体样式
                            },
                        }
                    }
                }
            }
        });

        return () => {
            chart.destroy();
        };
    }, [data]);

    return <canvas ref={chartRef} />;
}

export default RadarChart;
